import { useState } from "react";
import { Popover } from "@headlessui/react";
import { usePopper } from "react-popper";

const POPOVER_OPTIONS: object = {
  placement: "top",
  strategy: "fixed",
  modifiers: [
    {
      name: "offset",
      options: {
        offset: [0, 12],
      },
    },
  ],
};

interface ToolbarPopoverProps {
  [key: string]: unknown;
  ButtonType: React.ElementType;
  children: React.ReactNode;
}

export const ToolbarPopover = ({
  ButtonType,
  children,
  ...rest
}: ToolbarPopoverProps) => {
  const [referenceElement, setReferenceElement] =
    useState<HTMLDivElement | null>();
  const [popperElement, setPopperElement] = useState<HTMLDivElement | null>();
  const { styles, attributes } = usePopper(
    referenceElement,
    popperElement,
    POPOVER_OPTIONS,
  );

  return (
    <Popover className="relative" {...rest}>
      <>
        <Popover.Button as={ButtonType} ref={setReferenceElement} />
        <Popover.Panel
          ref={setPopperElement}
          style={styles.popper}
          className="flex overflow-hidden rounded-2xl border border-[#42454d] bg-[#191a1e] text-sm font-medium text-[#F0F3F5] shadow"
          {...attributes.popper}
        >
          {children}
        </Popover.Panel>
      </>
    </Popover>
  );
};
